import React from 'react';
import { Card } from './ui/Card';
import { CheckCircle2, BookOpen, Users, Sparkles } from 'lucide-react';
export function ProductBreakdown() {
  return <section className="py-24 bg-gray-50" id="que-incluye" data-id="element-100">
      <div className="container mx-auto px-4" data-id="element-101">
        <div className="text-center mb-20" data-id="element-102">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-black text-gray-900 mb-6 leading-tight" data-id="element-103">
            ¿Qué Incluye el{' '}
            <span className="text-red-700" data-id="element-104">MegaPack Música Lista</span>?
          </h2>
          <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-105">
            Todo lo que necesitás para tus clases, organizado por niveles y
            objetivos, para que puedas aplicar sin perder horas armando material
            desde cero.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-7xl mx-auto" data-id="element-106">
          {/* Primaria */}
          <Card className="flex flex-col h-full hover:shadow-2xl transition-all duration-300 border-t-4 border-t-amber-500 hover:-translate-y-2" data-id="element-107">
            <div className="h-56 overflow-hidden relative group" data-id="element-108">
              <img src="https://cdn.magicpatterns.com/uploads/sZnBXKBgxS1Hr7bzfYr5xD/imagen_1.png" alt="Música Primaria" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-109" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-6" data-id="element-110">
                <h3 className="text-2xl md:text-3xl font-black text-white flex items-center gap-2" data-id="element-111">
                  <BookOpen className="w-7 h-7 text-amber-400" data-id="element-112" />
                  Nivel Primaria
                </h3>
              </div>
            </div>
            <div className="p-8 flex-1 flex flex-col" data-id="element-113">
              <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-114">
                Material lúdico, claro y súper aplicable para introducir (o
                fortalecer) los contenidos musicales con niños.
              </p>
              <ul className="space-y-3.5 mb-8 flex-1" data-id="element-115">
                <li className="flex items-start gap-3" data-id="element-116">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" data-id="element-117" />
                  <span className="text-base text-gray-700 leading-snug" data-id="element-118">
                    Planificaciones semanales detalladas
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-119">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" data-id="element-120" />
                  <span className="text-base text-gray-700 leading-snug" data-id="element-121">
                    Juegos rítmicos y dinámicas de movimiento
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-122">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" data-id="element-123" />
                  <span className="text-base text-gray-700 leading-snug" data-id="element-124">
                    Actividades de percusión corporal e instrumentos escolares
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-125">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" data-id="element-126" />
                  <span className="text-base text-gray-700 leading-snug" data-id="element-127">
                    Proyectos cortos (canción, ritmo, ensamble simple)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-128">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" data-id="element-129" />
                  <span className="text-base text-gray-700 leading-snug" data-id="element-130">
                    Evaluaciones y criterios adaptados por edad
                  </span>
                </li>
              </ul>
            </div>
          </Card>

          {/* Secundaria */}
          <Card className="flex flex-col h-full hover:shadow-2xl transition-all duration-300 border-t-4 border-t-red-600 transform md:-translate-y-6 hover:-translate-y-8" data-id="element-131">
            <div className="h-56 overflow-hidden relative group" data-id="element-132">
              <img src="https://cdn.magicpatterns.com/uploads/ug3z7yyWbqEgzXgHNXMQW3/imagen_2.png" alt="Música Secundaria" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-133" />
              <div className="absolute top-4 right-4 bg-red-600 text-white text-sm font-black px-4 py-2 rounded-full shadow-xl animate-pulse" data-id="element-134">
                MÁS POPULAR
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-6" data-id="element-135">
                <h3 className="text-2xl md:text-3xl font-black text-white flex items-center gap-2" data-id="element-136">
                  <Users className="w-7 h-7 text-red-400" data-id="element-137" />
                  Nivel Secundaria
                </h3>
              </div>
            </div>
            <div className="p-8 flex-1 flex flex-col bg-white" data-id="element-138">
              <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-139">
                Propuestas creativas y actuales para adolescentes, enfocadas en
                interpretación, creación y trabajo en equipo.
              </p>
              <ul className="space-y-3.5 mb-8 flex-1" data-id="element-140">
                <li className="flex items-start gap-3" data-id="element-141">
                  <CheckCircle2 className="w-5 h-5 text-red-600 flex-shrink-0 mt-1" data-id="element-142" />
                  <span className="text-base text-gray-700 leading-snug" data-id="element-143">
                    Planificaciones anuales completas
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-144">
                  <CheckCircle2 className="w-5 h-5 text-red-600 flex-shrink-0 mt-1" data-id="element-145" />
                  <span className="text-base text-gray-700 leading-snug" data-id="element-146">
                    Actividades de producción y creación musical guiada
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-147">
                  <CheckCircle2 className="w-5 h-5 text-red-600 flex-shrink-0 mt-1" data-id="element-148" />
                  <span className="text-base text-gray-700 leading-snug" data-id="element-149">
                    Recursos para ensambles, arreglos y armado de repertorio
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-150">
                  <CheckCircle2 className="w-5 h-5 text-red-600 flex-shrink-0 mt-1" data-id="element-151" />
                  <span className="text-base text-gray-700 leading-snug" data-id="element-152">
                    Proyectos por etapas (inicio → desarrollo → muestra final)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-153">
                  <CheckCircle2 className="w-5 h-5 text-red-600 flex-shrink-0 mt-1" data-id="element-154" />
                  <span className="text-base text-gray-700 leading-snug" data-id="element-155">
                    Rúbricas y herramientas de evaluación claras
                  </span>
                </li>
              </ul>
            </div>
          </Card>

          {/* Bonos */}
          <Card className="flex flex-col h-full hover:shadow-2xl transition-all duration-300 border-t-4 border-t-purple-600 hover:-translate-y-2" data-id="element-156">
            <div className="h-56 overflow-hidden relative group" data-id="element-157">
              <img src="https://cdn.magicpatterns.com/uploads/3fbu2BS6WRWcT9ZFxGtQmG/imagen3.png" alt="Bonos Exclusivos" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-158" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-6" data-id="element-159">
                <h3 className="text-2xl md:text-3xl font-black text-white flex items-center gap-2" data-id="element-160">
                  <Sparkles className="w-7 h-7 text-purple-400" data-id="element-161" />
                  Bonos Exclusivos
                </h3>
              </div>
            </div>
            <div className="p-8 flex-1 flex flex-col" data-id="element-162">
              <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-163">
                Recursos extra para enriquecer tus clases y resolver imprevistos
                sin estrés.
              </p>
              <ul className="space-y-3.5 mb-8 flex-1" data-id="element-164">
                <li className="flex items-start gap-3" data-id="element-165">
                  <CheckCircle2 className="w-5 h-5 text-purple-600 flex-shrink-0 mt-1" data-id="element-166" />
                  <span className="text-base text-gray-700 leading-snug" data-id="element-167">
                    Banco de 100+ dinámicas (ritmo, escucha, creación,
                    integración grupal)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-168">
                  <CheckCircle2 className="w-5 h-5 text-purple-600 flex-shrink-0 mt-1" data-id="element-169" />
                  <span className="text-base text-gray-700 leading-snug" data-id="element-170">
                    Ideas para actos escolares y muestras musicales
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-171">
                  <CheckCircle2 className="w-5 h-5 text-purple-600 flex-shrink-0 mt-1" data-id="element-172" />
                  <span className="text-base text-gray-700 leading-snug" data-id="element-173">
                    Kit de partituras/guías editables (según tu formato de
                    trabajo)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-174">
                  <CheckCircle2 className="w-5 h-5 text-purple-600 flex-shrink-0 mt-1" data-id="element-175" />
                  <span className="text-base text-gray-700 leading-snug" data-id="element-176">
                    Planillas de seguimiento y registro de progreso
                  </span>
                </li>
              </ul>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}